import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccesoDenegadoComponent } from './componentes/acceso-denegado/acceso-denegado.component';
import { LayoutComponent } from './componentes/layout/layout.component';
import { LoginComponent } from './componentes/login/login.component';
import { MenuCertificacionesComponent } from './componentes/menu-certificaciones/menu-certificaciones.component';
import { MenuOpcionesCertificadosComponent } from './componentes/menu-opciones-certificados/menu-opciones-certificados.component';
import { MenuPerfilComponent } from './componentes/menu-perfil/menu-perfil.component';
import { PaginaNoEncontradaComponent } from './componentes/pagina-no-encontrada/pagina-no-encontrada.component';
import { ValidacionCertificadoComponent } from './componentes/validacion-certificado/validacion-certificado.component';
import { perfiles } from './core/constantes/constantes-perfiles';
import { AuthorizationGuard } from './core/guardianes/authorization.guard';
import { IsLogedGuard } from './core/guardianes/is-loged.guard';
import { IsLoginGuard } from './core/guardianes/is-login.guard';

const routes: Routes = [

  { path: 'verificacion-certificado/:strCodificado', component: ValidacionCertificadoComponent },
  { path: '', pathMatch: 'full', redirectTo: '/login' },

  { path: 'login', component: LoginComponent, canActivate: [IsLoginGuard] },
  { path: 'menu-perfil', component: MenuPerfilComponent, canActivate: [IsLogedGuard] },  
  { path: '', component: LayoutComponent, children: [
    { path: 'menu-certificaciones', component: MenuCertificacionesComponent, canActivate: [AuthorizationGuard], data: {autoridades: [perfiles.estudiante, perfiles.graduado] } },
    { path: 'menu-opciones-certificados/:liqCodigo/:facCodigo/:litCodigo', component: MenuOpcionesCertificadosComponent, canActivate: [AuthorizationGuard], data: {autoridades: [perfiles.estudiante, perfiles.graduado] } },
  ]},
  
  { path: 'pagina-no-encontrada', component: PaginaNoEncontradaComponent },
  { path: 'acceso-denegado', component: AccesoDenegadoComponent },
  { path: '**', redirectTo: '/pagina-no-encontrada' }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }


